module.exports = class Disc {
  static get cssName() {
    return 'disc';
  }

  render() {
    return '•';
  }
};
